module.exports = __webpack_public_path__ + "static/extend-wifi-range-mhotspot-0e718cd1b6c448d935a8abc07dda088a.jpg";